<div class="container-fluid cancel-exchange-confirmation" *ngIf="isCancelConfirmation">
  <h4>Are you sure you want to leave this page?</h4>
  <p>
    You are about to leave the page before you have committed to an exchange for Deal
    {{ dealNumber }}. None of the information you have entered will be saved. To get it back you
    will need to request a new exchange.
  </p>
</div>
